"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconMap = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
require("./styles.css");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
exports.iconMap = {
    angleDown: free_solid_svg_icons_1.faAngleDown,
    angleUp: free_solid_svg_icons_1.faAngleUp,
    arrowRight: free_solid_svg_icons_1.faArrowRight,
    close: free_solid_svg_icons_1.faClose,
    filter: free_solid_svg_icons_1.faFilter,
    home: free_solid_svg_icons_1.faHome,
    pen: free_solid_svg_icons_1.faPen,
    search: free_solid_svg_icons_1.faSearch,
    share: free_solid_svg_icons_1.faShare,
    xmark: free_solid_svg_icons_1.faXmark,
    xmarkCircle: free_solid_svg_icons_1.faXmarkCircle,
};
function IconFont(props) {
    var icon = exports.iconMap[props.type];
    var size = props.size || 'sm';
    var color = props.color ? { color: props.color } : {};
    var style = props.style ? { style: props.style } : {};
    var classes = (0, classnames_1.default)(props.className, 'rwc-icon', "size-".concat(size));
    return ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, __assign({ icon: icon, className: classes }, color, style)));
}
exports.default = IconFont;
//# sourceMappingURL=icon-font.js.map